import { render, staticRenderFns } from "./ItemListUserLayout.vue?vue&type=template&id=47b2bad4&scoped=true&"
import script from "./ItemListUserLayout.vue?vue&type=script&lang=js&"
export * from "./ItemListUserLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47b2bad4",
  null
  
)

export default component.exports